// ReportHeader.js - универсальный компонент для шапки отчетов
import React from 'react';
import { Card, Typography } from 'antd';
import { BuildOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;

const ReportHeader = ({ title, subtitle, period, generatedAt }) => {
    return (
        <Card
            style={{
                marginBottom: 16,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none'
            }}
            styles={{ body: {padding: '16px 24px'} }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '8px',
                        padding: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <BuildOutlined style={{ fontSize: '24px', color: '#667eea' }} />
                    </div>
                    <div>
                        <Title level={3} style={{ color: 'white', margin: 0 }}>
                            {title}
                        </Title>
                        {subtitle && (
                            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '14px' }}>
                                {subtitle}
                            </Text>
                        )}
                    </div>
                </div>
                <div style={{ textAlign: 'right', color: 'white' }}>
                    {period && (
                        <Text strong style={{ display: 'block', color: 'white', fontSize: '14px' }}>
                            {period}
                        </Text>
                    )}
                    {generatedAt && (
                        <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
                            Сгенерировано: {generatedAt}
                        </Text>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default ReportHeader;